/* */ 
module.exports = require('./lib/_stream_passthrough');
